import {FrontendEvent, Measure} from "@core/model";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

type EventState = {
  lastEvent?: FrontendEvent;
  events: FrontendEvent[];
  measures: Measure<number>[];
};

const initialState: EventState = {
  lastEvent: undefined,
  events: [],
  measures: [],
};

export const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    notify: (state: EventState, action: PayloadAction<FrontendEvent>) => {
      if (action.payload.type === "measure") {
        state.measures = [...state.measures, ...action.payload.payload].sort(
          (a, b) =>
            new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime(),
        );
      } else {
        state.lastEvent = action.payload;
        const found =
          state.events.findIndex(e => e.date === action.payload.date) !== -1;
        if (!found) {
          state.events = [...state.events, action.payload];
        }
      }
    },
    clearEvents: state => {
      state.events = [];
      state.lastEvent = undefined;
    },
  },
});

export const {notify, clearEvents} = eventSlice.actions;

export default eventSlice.reducer;
